export function isJsonLottieString(jsonString) {
  try {
    const parsedJson = JSON.parse(jsonString);
    if (
      parsedJson &&
      typeof parsedJson === 'object' &&
      parsedJson?.layers?.length
    ) {
      return parsedJson;
    }
  } catch (e) {
    return false;
  }
  return false;
}

export const animationModes = {
  SEEK: 'seek',
  PLAY: 'play',
};

export function interactivity(animationMode, visibility, frames) {
  const modesObj = {
    [animationModes.SEEK]: {
      // On Scroll
      player: '#lottie-player',
      mode: 'scroll',
      actions: [
        {
          visibility: [Number(visibility?.x), Number(visibility?.y)],
          type: 'seek',
          frames: [Number(frames?.x), Number(frames?.y)],
        },
      ],
    },
    [animationModes.PLAY]: {
      // When Visible
      player: '#lottie-player',
      mode: 'scroll',
      actions: [
        {
          visibility: [Number(visibility?.x), Number(visibility?.y)],
          type: 'play',
        },
      ],
    },
  };
  const type = modesObj[animationMode];
  return type;
}
